// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/ed3fd329d3fb358d6747.bundle.js";
	if (chunkId === 3) return "static/js/eb8ae9d942e19ca1dea2.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"4443fc1d98bb2ae2afbc","139":"6cde8730767feec948cc","140":"59e731a8eeb84ab269a2"}[chunkId] + ".chunk.js";
};